import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '@/App';
import '@/lib/i18n'; // initialise react-i18next before any component renders
import '@/index.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root missing from index.html');

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
